import Reject from "./Reject";

export default Reject;
